import { Grid2Props as GridProps } from "@mui/material";
import { PropsWithChildren } from "react";
import { NestedGrid } from "src/components/layout/page-grid/deprecated/NestedGrid";

interface EKPNestedGridProps extends GridProps {
    /**
     * To distinguish between Pages which contain a SideMenu and the columns behave differently.
     * If set true the columns will be set to: { xs: 6, sm: 12, md: 9, lg: 12 }
     * @Default columns={{ xs: 4, sm: 8, lg: 12 }}
     */
    pageContainsSideMenu?: boolean;
}

/**
 * NestedGrid used to structure nested content inside a page in the EKP.
 */
export const EKPNestedGrid = (props: PropsWithChildren<EKPNestedGridProps>) => {
    return (
        <NestedGrid
            spacing={{ xsMobile: 2, sm: 3 }}
            columns={
                props.pageContainsSideMenu
                    ? { xsMobile: 6, sm: 12, md: 9, lg: 12 }
                    : { xsMobile: 2, xs: 4, tablet: 6, sm: 8, md: 8, lg: 12 }
            }
            {...props}
        />
    );
};
